import React, { useEffect, useState } from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

interface SummarySectionProps {
  isEditable: boolean;
  selectedAssesmentData:any
  summaryDat:any
  /** While editing, reflect recalculated totals from the parent. */
  liveTotals?: { totalPoints: number; potentialPoints: number };
  /** Read-only: Σ engagement potential_improvement × net new licenses (matches calculator). */
  viewPotentialPoints?: number;
}

const SummarySection: React.FC<SummarySectionProps> = ({
  isEditable,
  selectedAssesmentData,
  summaryDat,
  liveTotals,
  viewPotentialPoints,
}) => {
  const [formData, setFormData] = useState({
    currentTier: selectedAssesmentData.tier_name || 'Registered',
    totalPoints: selectedAssesmentData.total_partner_points || 0,
    pointsToNextTier: summaryDat?.next_tier_progress?.value?.points_required || 0 ,
    licencesToNextTier: summaryDat?.next_required_license?.value?.licenses_required || 0,
    potentialPoints: selectedAssesmentData.potential_improvement || 0,
  });

  useEffect(() => {
    setFormData({
      currentTier: selectedAssesmentData?.tier_name || "Registered",
      totalPoints: selectedAssesmentData?.total_partner_points || 0,
      pointsToNextTier:
        summaryDat?.next_tier_progress?.value?.points_required || 0,
      licencesToNextTier:
        summaryDat?.next_required_license?.value?.licenses_required || 0,
      potentialPoints: selectedAssesmentData?.potential_improvement || 0,
    });
  }, [selectedAssesmentData, summaryDat]);

  const displayTotalPoints =
    liveTotals?.totalPoints ?? formData.totalPoints;
  const displayPotential =
    liveTotals?.potentialPoints ??
    (viewPotentialPoints !== undefined
      ? viewPotentialPoints
      : formData.potentialPoints);

  const summaryData = [
    {
      icon: "award",
      label: "Current Tier",
      value: formData.currentTier,
      field: "currentTier",
      color: "green",
    },
    {
      icon: "arrowTrendUp",
      label: "Total Points",
      value: liveTotals ? Math.round(displayTotalPoints) : displayTotalPoints,
      field: "totalPoints",
      color: "orange",
    },
    {
      icon: "circlePlus",
      label: "Points to next Tier",
      value: formData.pointsToNextTier.toLocaleString(),
      field: "pointsToNextTier",
      color: "purple",
    },
    {
      icon: "circleStar",
      label: "licences to next Tier",
      value: formData.licencesToNextTier.toLocaleString(),
      field: "licencesToNextTier",
      color: "cyan",
    },
    {
      icon: "fileCheck",
      label: "Potential Points",
      value: displayPotential.toLocaleString(),
      field: "potentialPoints",
      color: "orange",
    },
  ];





  const handleInputChange = (field: string, value: string | number) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="detail-section">
      <h2>Summary</h2>
      <div className="summary-grid">
        {summaryData.map((item, index) => (
          <div key={index} className={`summary-card ${item.color}-light`}>
            <div className="card-content">
              <div className="card-left">
                <Iconography
                  icon={item.icon as any}
                  size={IconographySizes.Medium}
                />
                <span className="card-label">{item.label}</span>
              </div>
              {isEditable ? (
                <input
                  type="text"
                  className="card-input"
                  value={item.value}
                  onChange={(e) => handleInputChange(item.field, e.target.value)}
                />
              ) : (
                <span className="card-value">{item.value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummarySection;
